import { ROLE_ADMIN, ROLE_ANALYST, ROLE_CORRESPONDENT, RUBIX, CORRESPONDENT } from '../../../constants'

export const identifyRole = (sender) => {
    switch (sender) {
        case ROLE_ADMIN:
            return RUBIX
        case ROLE_ANALYST:
            return RUBIX
        case ROLE_CORRESPONDENT:
            return CORRESPONDENT
        default:
            return sender
    }
}